import { render } from "./HausStep1.vue?vue&type=template&id=784a05fe&scoped=true"
import script from "./HausStep1.vue?vue&type=script&lang=js"
export * from "./HausStep1.vue?vue&type=script&lang=js"

import "./HausStep1.vue?vue&type=style&index=0&id=784a05fe&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784a05fe"]])

export default __exports__